import printComponent from './print_physical_cash_count.component';
import './print_physical_cash_count.scss';

let printModule = angular.module('printPhysicalCashCount', [
])
    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $urlRouterProvider.otherwise('/branchManagement.physicalCashCount');

        $stateProvider
            .state('printPhysicalCashCount', {
                url: '/print-physical-cash-count',
                component: 'printPhysicalCashCount',
                data: {
                    requireLogin: true,
                    requireACL: 'branch_mgmt_physical_cash_count.all'
                },
            })
    })

    .component('printPhysicalCashCount', printComponent)

    .name;

export default printModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/physical_cash_count/print/index.js